import { ComboBox, defaultTheme, Item, Provider, Section } from '@adobe/react-spectrum'
import { forwardRef } from 'react'

import { cn } from '@repo/utils'

export interface DropdownProps {
  className?: string
  disabled?: boolean
  required?: boolean
  transparent?: boolean
}

export const Dropdown = forwardRef<HTMLDivElement, DropdownProps>(
  ({ className, disabled = false, required = false, transparent = false, ...props }, ref) => (
    <div
      {...props}
      className={cn('Dropdown', className)}
      data-disabled={disabled}
      data-required={required}
      data-transparent={transparent}
      ref={ref}
    >
      <div>
        <Provider theme={defaultTheme}>
          <ComboBox label="Preferred fruit or vegetable">
            <Section title="Fruit">
              <Item key="Apple">Apple</Item>
              <Item key="Banana">Banana</Item>
              <Item key="Orange">Orange</Item>
              <Item key="Honeydew">Honeydew</Item>
              <Item key="Grapes">Grapes</Item>
              <Item key="Watermelon">Watermelon</Item>
              <Item key="Cantaloupe">Cantaloupe</Item>
              <Item key="Pear">Pear</Item>
            </Section>
            <Section title="Vegetable">
              <Item key="Cabbage">Cabbage</Item>
              <Item key="Broccoli">Broccoli</Item>
              <Item key="Carrots">Carrots</Item>
              <Item key="Lettuce">Lettuce</Item>
              <Item key="Spinach">Spinach</Item>
              <Item key="Bok Choy">Bok Choy</Item>
              <Item key="Cauliflower">Cauliflower</Item>
              <Item key="Potatoes">Potatoes</Item>
            </Section>
          </ComboBox>
        </Provider>
      </div>
      <div>
        <div className="ui form">
          {/* <Select */}
          {/*  label="Preferred fruit or vegetable" */}
          {/*  name="name" */}
          {/*  onChange={console.log} */}
          {/*  options={friendOptions} */}
          {/*  placeholder="Preferred fruit or vegetable" */}
          {/* /> */}
        </div>
      </div>
    </div>
  ),
)

Dropdown.displayName = 'Dropdown'
